import {TiGroup} from "react-icons/ti";
import {TbEmergencyBed} from "react-icons/tb";
import {FaHandHoldingHeart} from "react-icons/fa";
import {MdOutlineBloodtype} from "react-icons/md";
import {PiBandaidsFill} from "react-icons/pi";
import {LiaStarOfLifeSolid} from "react-icons/lia";
import useScrollRestoration from "../../utils/scrollRestoration";

export default function Home() {
    useScrollRestoration()
    return (
        <>
            <section
                className="px-2 md:px-24 flex bg-cover bg-left md:bg-center bg-home-banner h-[600px] min-h-[650px]
            md:min-h-[800px] items-center mt-18 md:mt-12">
                <div className="mx-2 md:mx-24 pl-2 md:w-2/3 h-1/2 flex-col">
                    <h1 className="font-playfair-display font-extrabold md:text-[45px] text-[2.2rem]">Making Health</h1>
                    <h1 className="font-playfair-display font-extrabold md:text-[45px] text-[2.2rem]">Care Better
                        Together</h1>
                    <p className="text-gray-500 mt-6 leading-8 max-w-[400px]"> We are committed to advancing healthcare
                        through unity
                        and care. By working hand-in-hand with patients and professionals, we aim to deliver exceptional
                        medical services that promote wellness and create lasting change in the community</p>

                    <button type="button"
                            className="mt-6 bg-yellow-600 py-4 text-white px-5 font-playfair-display font-bold hover:bg-white
                         hover:text-yellow-500 hover:border-2 hover:border-yellow-500">Make
                        An Appointment
                    </button>
                </div>


            </section>

            <section className="bg-yellow-600 py-32 px-2 md:px-2 items-center">
                <div
                    className="h-full mx-2 md:mx-24 pl-2 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3
                    items-center justify-between text-center gap-8">
                    <div className="flex flex-1 flex-col max-w-100 lg:w-78 h-48 shadow bg-white items-center px-6">
                        <div className="flex flex-1 w-full flex-row mx-4 items-center justify-start gap-2">
                            <TiGroup className="text-yellow-600 text-3xl"/>
                            <p className="font-playfair-display font-extrabold text-xl">Medical Camp Organisers</p>
                        </div>
                        <p className="flex flex-1 w-full text-start text-gray-500"> Medical camp organizers set up
                            health
                            camps that
                            offer our services.</p>


                    </div>
                    <div className="flex flex-1 flex-col max-w-100 lg:w-78 h-48 shadow bg-white items-center px-6">
                        <div className="flex flex-1 w-full flex-row mx-4 items-center justify-start gap-2">
                            <TbEmergencyBed className="text-yellow-600 text-3xl"/>
                            <p className="font-playfair-display font-extrabold text-xl">Social Emergency Camps</p>
                        </div>
                        <p className="flex flex-1 w-full text-start text-gray-500">Social emergency camps deliver
                            immediate healthcare
                            services to communities in need.</p>

                    </div>
                    <div className="flex flex-1 flex-col max-w-100 lg:w-78 h-48 shadow bg-white items-center px-6">
                        <div className="flex flex-1 w-full flex-row mx-4 items-center justify-start gap-2 ">
                            <FaHandHoldingHeart className="text-yellow-600 text-3xl"/>
                            <p className="font-playfair-display font-extrabold text-xl">Community Services</p>
                        </div>
                        <p className="flex flex-1 w-full text-start text-gray-500"> Community services offer support and
                            resources to enhance the well-being of residents.</p>


                    </div>

                </div>

            </section>

            <section className="flex  h-[1800px] md:h-[1400px] lg:h-[1000px] flex-col">
                <div className="flex h-[600px] flex-row ">
                    <div className="bg-white text-black flex items-center flex-1 justify-center">
                        <div className="text-center p-4">
                            <h1 className="font-playfair-display text-[36px] font-bold">Aim to Make</h1>
                            <p className="font-playfair-display text-[36px] font-bold">INDIA Healthy</p>
                        </div>
                    </div>
                    <div className="flex flex-1 bg-cover bg-center bg-india relative">
                        <div className="absolute inset-0 bg-gradient-to-r from-white to-transparent"></div>
                    </div>

                </div>
                <div className="flex flex-1 bg-gray-300  relative">
                    <div className="absolute inset-0 bg-gradient-to-b from-white to-transparent"></div>
                    <div className="flex flex-1 -top-4 absolute w-full justify-around items-center gap-10">
                        <div
                            className="h-full mx-2 md:mx-24 pl-2 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3
                    items-center justify-between text-center gap-8">

                            <div
                                className="flex flex-1 flex-col max-w-100 lg:w-78 min-h-[350px] shadow bg-white items-center px-6 py-4 gap-6">
                                <div
                                    className="flex flex-1 w-full mx-4 items-center justify-start gap-2 border-b mt-2">
                                    <PiBandaidsFill className="text-yellow-600 text-[64px]"/>
                                </div>
                                <p className="font-playfair-display font-extrabold text-xl w-full justify-start text-start mt-2">NCD
                                    Control<br/>
                                    Programme</p>

                                <p className="flex flex-1 w-full text-start text-gray-500">The National Programme
                                    for Prevention and Control of Non-Communicable Diseases (NP-NCD) is a program in
                                    India that aims to prevent and control major non-communicable diseases (NCDs).</p>

                            </div>
                            <div
                                className="flex flex-1 flex-col max-w-100 lg:w-78 min-h-[350px] shadow bg-white items-center px-6 py-4 gap-6">
                                <div
                                    className="flex flex-1 w-full mx-4 items-center justify-start gap-2 border-b mt-2">
                                    <LiaStarOfLifeSolid className="text-yellow-600 text-[64px]"/>
                                </div>
                                <p className="font-playfair-display font-extrabold text-xl w-full justify-start text-start mt-2">Cancer
                                    Awareness<br/> INDIA Programme</p>

                                <p className="flex flex-1 w-full text-start text-gray-500">The Cancer Awareness India
                                    educates and inform people about cancer prevention, early detection,
                                    and treatment options. It focuses on spreading awareness through health camps,
                                    workshops, and media campaigns.</p>

                            </div>
                            <div
                                className="flex flex-1 flex-col max-w-100 lg:w-78 min-h-[350px] shadow bg-white items-center px-6 py-4 gap-6">
                                <div
                                    className="flex flex-1 w-full mx-4 items-center justify-start gap-2 border-b mt-2">
                                    <MdOutlineBloodtype className="text-yellow-600 text-[64px]"/>
                                </div>
                                <p className="font-playfair-display font-extrabold text-xl w-full justify-start text-start mt-2">Anemia
                                    Free<br/>INDIA
                                    Programme</p>

                                <p className="flex flex-1 w-full text-gray-500 text-start">The Anemia-Free India Program
                                    raises awareness about anemia, its causes and prevention. It promotes
                                    nutrition education, regular health check-ups, and iron supplementation, especially
                                    for women and children</p>

                            </div>

                        </div>
                    </div>
                </div>

            </section>

            <section
                className="flex flex-1 relative bg-cover bg-center md:bg-center bg-home-banner-1 h-[400px] min-h-[450px]
                 items-center justify-center text-center">
                <div className="absolute inset-0 bg-yellow-500 bg-opacity-70"></div>
                <div className="flex-1 container relative z-10 text-white space-y-4">
                    <h6 className="font-playfair-display text-2xl font-bold">Emergency
                        hotline</h6>
                    <h1 className="font-roboto text-[24px] md:text-[60px] font-extrabold tracking-wide">(+91)
                        9177869135</h1>
                    <p className="font-roboto">Please feel free to contact us for emergency case.</p>
                </div>

            </section>
            <section
                className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4 relative md:h-[300px] h-[650px]
                 items-center justify-center text-center gap-10 place-items-center mx-10">
                <div className="w-32 h-32 bg-cover bg-kona-bw hover:bg-kona cursor-pointer"></div>
                <div className="w-32 h-36 bg-cover bg-racc-bw hover:bg-racc cursor-pointer"></div>
                <div className="w-32 h-32 bg-cover bg-sai-sagar-bw hover:bg-sai-sagar cursor-pointer"></div>
                <div className="w-64 h-24 bg-cover bg-venkatarama-bw hover:bg-venkatarama cursor-pointer"></div>

            </section>

        </>

    );
}